"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMN = function FlagMN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80.07-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06H80.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "137.53",
    y: "1",
    width: "136.53",
    height: "268.36",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H-56.47V146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-124.45-11A26,26,0,0,1-148.3-26.61c0,.14,0,.27,0,.41A23.89,23.89,0,0,0-124.45-2.31,23.89,23.89,0,0,0-100.56-26.2c0-.14,0-.27,0-.41A26,26,0,0,1-124.45-11Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-107.07-32.72a17.38,17.38,0,0,1-17.38,17.38,17.38,17.38,0,0,1-17.37-17.38,17.37,17.37,0,0,1,17.37-17.37,17.38,17.38,0,0,1,17.38,17.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.31-65.3a10.86,10.86,0,0,0,10.86,10.86A10.86,10.86,0,0,0-113.59-65.3c0-4.34-2.72-4.89-2.72-6.51s1.63-3.8-1.62-6.52c1.62,2.72-1.09,3.26-1.09,6s1.09,2.72,1.09,4.89a2.18,2.18,0,0,1-2.18,2.17,2.16,2.16,0,0,1-2.16-2.17c0-2.17,2.16-4.34,2.16-7.6s-.54-4.35-2.16-7.06-4.35-4.89-2.18-7.06c-3.25,1.08-1.62,5.43-1.62,8.14s-2.18,4.35-2.18,7.61,1.63,3.8,1.63,6a2.17,2.17,0,0,1-2.17,2.17A2.17,2.17,0,0,1-131-67.47c0-2.17,1.08-2.17,1.08-4.89s-2.71-3.26-1.08-6c-3.26,2.72-1.63,4.89-1.63,6.52s-2.72,2.17-2.72,6.51Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-172.23,3.83V104.5a1.79,1.79,0,0,0,1.79,1.79h18.13a1.8,1.8,0,0,0,1.8-1.79V3.83A1.8,1.8,0,0,0-152.31,2h-18.13a1.79,1.79,0,0,0-1.79,1.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-98.38,3.83V104.5a1.79,1.79,0,0,0,1.79,1.79h18.13a1.8,1.8,0,0,0,1.8-1.79V3.83A1.8,1.8,0,0,0-78.46,2H-96.59a1.79,1.79,0,0,0-1.79,1.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-146.17,21.2v5.1a1.8,1.8,0,0,0,1.79,1.8h39.86a1.8,1.8,0,0,0,1.79-1.8V21.2a1.79,1.79,0,0,0-1.79-1.79h-39.86a1.79,1.79,0,0,0-1.79,1.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-146.17,82v5.1a1.79,1.79,0,0,0,1.79,1.79h39.86a1.79,1.79,0,0,0,1.79-1.79V82a1.79,1.79,0,0,0-1.79-1.79h-39.86A1.79,1.79,0,0,0-146.17,82Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-142.93,2h37a.9.9,0,0,1,.46,1.66l-17.56,10.53a2.65,2.65,0,0,1-2.77,0L-143.4,3.7A.9.9,0,0,1-142.93,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-142.93,93.26h37a.9.9,0,0,1,.46,1.67l-17.57,10.53a2.68,2.68,0,0,1-2.76,0L-143.4,94.93a.9.9,0,0,1,.47-1.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-122.33,32.61c-.68-.06-1.35-.21-2-.21A21.69,21.69,0,0,0-146,54.07a21.5,21.5,0,0,0,8.75,17.26.74.74,0,0,0,1.12-.9,12.58,12.58,0,0,1-1-4.88,12.8,12.8,0,0,1,12.82-12.78,9.75,9.75,0,0,0,8.92-5.16,10.3,10.3,0,0,0-6.91-15Zm-2,14.31a4.33,4.33,0,0,1-4.33-4.33,4.33,4.33,0,0,1,4.33-4.34A4.34,4.34,0,0,1-120,42.59a4.34,4.34,0,0,1-4.34,4.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-111.47,36.8a.75.75,0,0,0-1.12.9,12.42,12.42,0,0,1,1,4.89,12.8,12.8,0,0,1-12.82,12.78,9.74,9.74,0,0,0-8.92,5.15,10.3,10.3,0,0,0,6.91,15,20,20,0,0,0,2.05.21,21.68,21.68,0,0,0,21.66-21.66,21.49,21.49,0,0,0-8.75-17.27Zm-12.91,33.08a4.33,4.33,0,0,1-4.33-4.33,4.33,4.33,0,0,1,4.33-4.33A4.33,4.33,0,0,1-120,65.55a4.34,4.34,0,0,1-4.34,4.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#f9cf02"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMN;
exports["default"] = _default;